import GtmEvent from "web/Layout/Gtm/GtmEvent";

import Page404 from "./page404";

const gtmOptions = { cgroup1: "404" };

const Page404Container = () => (
  <>
    <Page404 />
    <GtmEvent options={gtmOptions} withUrl />
  </>
);

export default Page404Container;
